import { store } from '../../store'

export const rename = async ( id: number, type: string, name: string ) => {

    let response: Response

    try {
        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/media-library/${ id }/rename?type=${ type }&name=${ name }`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: `POST`
        } )

    } catch ( exception ) {
        store.dispatch( { type: 'MEDIA_LIBRARY_RENAME_TIMEOUT' } )
        return
    }

    if ( response.status === 401 ) {
        store.dispatch( { type: 'MEDIA_LIBRARY_RENAME_UNAUTHORIZED' } )
        return
    }

    if ( response.status !== 200 ) {
        store.dispatch( { type: 'MEDIA_LIBRARY_RENAME_UNEXPECTEDRESPONSE' } )
        return
    }

    store.dispatch( { type: 'MEDIA_LIBRARY_RENAME_OK' } )

}
